
const digest = '39a2a7148eb197425e2f5e62a1fb92023aa6314c0687fba11d6218351837ebb7';
const classes = {"wrapper":"_wrapper_1wdy5_1","text":"_text_1wdy5_10","fakeInput":"_fakeInput_1wdy5_14","button":"_button_1wdy5_38","input":"_input_1wdy5_53"};
const css = `._wrapper_1wdy5_1 {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  justify-content: center;
  width: 100%;
}

._text_1wdy5_10 {
  font-size: 14px;
}

._fakeInput_1wdy5_14 {
  height: auto !important;
  border: 1px solid #e2e5ed;
  min-height: 55px;
  max-height: 55px;
  font-family: Rubik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  border-right: 0;
  border-radius: 24.5px;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  padding: 10px 0 10px 20px;
  color: #000;
  background-color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
._fakeInput_1wdy5_14:focus-within {
  box-shadow: 0 0 0 3px rgba(22, 101, 216, 0.15), inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-color: #1665d8;
  color: #000;
}
._fakeInput_1wdy5_14 ._button_1wdy5_38 {
  color: #1665d8;
  display: flex;
  height: 55px;
  border-left: 1px #e2e5ed solid;
  padding: 15px 20px;
  font-weight: 500;
  border-top-right-radius: 24.5px;
  border-bottom-right-radius: 24.5px;
}
._fakeInput_1wdy5_14 ._button_1wdy5_38:hover {
  background-color: #1665d8;
  color: #ffffff;
}

._input_1wdy5_53 {
  border: 0;
  flex: 1;
}
._input_1wdy5_53:focus {
  outline: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  